var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "546px",
    height: "300px",
    viewBox: "0 0 546 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(153.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.997352,71.8037996 C60.3375918,71.8037996 11.798504,120.342887 11.798504,180.007943 C11.798504,239.662408 60.3375918,288.201496 119.997352,288.201496 C179.662408,288.201496 228.201496,239.662408 228.201496,180.007943 C228.201496,120.342887 179.662408,71.8037996 119.997352,71.8037996 M119.997352,300.005296 C53.8293506,300.005296 0,246.175945 0,180.007943 C0,113.834646 53.8293506,60 119.997352,60 C186.170649,60 240,113.834646 240,180.007943 C240,246.175945 186.170649,300.005296 119.997352,300.005296",
    id: "Fill-1",
    fillOpacity: 0.25,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.997352,11.8037996 C60.3375918,11.8037996 11.798504,60.3428874 11.798504,120.007943 C11.798504,179.662408 60.3375918,228.201496 119.997352,228.201496 C179.662408,228.201496 228.201496,179.662408 228.201496,120.007943 C228.201496,60.3428874 179.662408,11.8037996 119.997352,11.8037996 M119.997352,240.005296 C53.8293506,240.005296 0,186.175945 0,120.007943 C0,53.8346462 53.8293506,0 119.997352,0 C186.170649,0 240,53.8346462 240,120.007943 C240,186.175945 186.170649,240.005296 119.997352,240.005296",
    id: "Fill-4",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.59372,6 L123.59372,147.463599 L153,147.463599 L153,169.553571 L123.59372,169.553571 L123.59372,219 L96.5166508,219 L96.5166508,169.553571 L0,169.553571 L0,153.60783 L94.9153187,6 L123.59372,6 Z M96,44 L92.794702,49.8263305 L30,148 L96,148 L96,44 Z",
    id: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.59372,6 L516.59372,147.463599 L546,147.463599 L546,169.553571 L516.59372,169.553571 L516.59372,219 L489.516651,219 L489.516651,169.553571 L393,169.553571 L393,153.60783 L487.915319,6 L516.59372,6 Z M489,44 L485.794702,49.8263305 L423,148 L489,148 L489,44 Z",
    id: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.806b4002411f1e64fdf765fac32bb96f.svg";
export { ForwardRef as ReactComponent };